<template>
  <div class="login-otp">
    <div class="login-form__field">
      <label class="login-form__label" id="login-otp-label">
        Verification code
      </label>
      <div
        class="login-otp__digits"
        role="group"
        aria-labelledby="login-otp-label"
        aria-describedby="login-otp-hint"
      >
        <v-text-field
          v-for="(_, index) in 6"
          :key="index"
          :ref="(el) => setOtpRef(index, el)"
          :model-value="digits[index]"
          type="text"
          inputmode="numeric"
          maxlength="1"
          variant="outlined"
          density="compact"
          class="login-otp__digit"
          :class="{ 'login-otp__digit--filled': digits[index] }"
          hide-details
          :disabled="disabled"
          :aria-label="`Digit ${index + 1} of 6`"
          @update:model-value="(val) => $emit('digit-input', index, val)"
          @keydown="(e) => $emit('keydown', index, e)"
          @paste="(e) => $emit('paste', index, e)"
          @keyup.enter="$emit('verify')"
        />
      </div>
      <span id="login-otp-hint" class="login-otp__meta-label">
        Code sent to {{ maskedEmail }}
      </span>
    </div>

    <div class="login-otp__meta">
      <div
        class="login-otp__timer"
        :class="{ 'login-otp__timer--urgent': timerUrgent }"
        role="timer"
        :aria-label="`Time remaining: ${timerDisplay}`"
      >
        <svg viewBox="0 0 36 36" class="login-otp__timer-svg" aria-hidden="true">
          <circle class="login-otp__timer-track" cx="18" cy="18" r="15.5" />
          <circle
            class="login-otp__timer-progress"
            cx="18"
            cy="18"
            r="15.5"
            :style="{ '--login-timer-offset': timerRingOffset }"
          />
        </svg>
        <span class="login-otp__timer-value">{{ timerDisplay }}</span>
      </div>
      <span class="login-otp__meta-label">until expiry</span>
    </div>

    <button
      type="button"
      class="login-btn login-btn--primary"
      :disabled="disabled || !isComplete || loading"
      :aria-busy="loading"
      @click="$emit('verify')"
    >
      <v-icon icon="mdi-login" class="login-btn__icon" />
      Verify &amp; sign in
    </button>

    <div class="login-form__actions">
      <button
        type="button"
        class="login-btn login-btn--ghost"
        :disabled="resendDisabled || loading"
        @click="$emit('resend')"
      >
        Resend code
      </button>
      <button
        type="button"
        class="login-btn login-btn--ghost"
        :disabled="loading"
        @click="$emit('change-email')"
      >
        Change email
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

defineOptions({ name: 'LoginOtpStep' })

const props = defineProps({
  digits: {
    type: Array,
    required: true,
  },
  maskedEmail: {
    type: String,
    default: '',
  },
  timerDisplay: {
    type: String,
    default: '0:00',
  },
  timerRingOffset: {
    type: Number,
    default: 0,
  },
  timerUrgent: {
    type: Boolean,
    default: false,
  },
  isComplete: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  resendDisabled: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits([
  'verify',
  'resend',
  'change-email',
  'digit-input',
  'keydown',
  'paste',
  'register-refs',
])

const otpRefs = ref({})

function setOtpRef(index, el) {
  if (el) {
    otpRefs.value[`otpInput${index}`] = el
    emit('register-refs', otpRefs.value)
  }
}
</script>
